class Util
{
    /**
     * Get a unique ID based on the current time.
     *
     * @param  {string|void} prefix
     * @return {string}
     */
    static uniqid(prefix) {
        return (prefix || '') + Date.now().toString(16)
    }
}

export default Util
